// Endpoint whitelists for the legacy AngularJS DateTimeInterceptor (date-time-inteceptor.service.js).
// They live in their own module so the Angular12 interceptor's parity spec can import them and check
// that every URL converted here is converted the same way there (SB-16586).

export const legacyDateTimeWhitelist = {
    // case-sensitive, keep alphabetical please!
    '/Balance/GetTransactions': [
        'eventsFrom',
        'eventsTo',
        'eventDateUtc',
    ],
    '/BalanceAdmin/ChaseEvent': [
        'eventsFrom',
        'eventsTo',
        'eventDateUtc',
    ],
    '/BalanceAdmin/GetEvents': ['fromUtc'],
    '/BalanceAdmin/GetEventTransactions': [
        'eventsFrom',
        'eventsTo',
        'eventDateUtc',
    ],
    '/BalanceAdmin/GetPersonTransactions': [
        'eventsFrom',
        'eventsTo',
        'eventDateUtc',
    ],
    '/BalanceAdmin/GetTransactionSummary': [
        'eventsFrom',
        'eventsTo',
        'eventDateUtc',
    ],
    '/CcaAvailable/CancelBooking': ['fromUtc', 'toUtc'],
    '/CcaAvailable/GetSignUp': ['openDateUtc', 'closeDateUtc'],
    '/CcaAvailable/GetSignUpBookedEvents': ['fromUtc', 'toUtc'],
    '/CcaAvailable/GetSignUpEvents': ['fromUtc', 'toUtc'],
    '/CcaAvailable/GetSignUps': ['openDateUtc', 'closeDateUtc'],
    '/CcaAvailable/ToggleBooking': ['fromUtc', 'toUtc'],
    '/CcaAvailable/ToggleBookings': [
        'fromUtc',
        'toUtc',
        'startDateTimeUtc',
    ],
    '/CcaAvailable/SaveBookings': ['startDateTimeUtc'],
    '/CcaSignUp/GetCcaStaffAttendees': ['fromUtc', 'toUtc'],
    '/CcaSignUp/GetSignUpBookedEvents': ['fromUtc', 'toUtc'],
    '/CcaSignUp/GetSignUpEvents': ['fromUtc', 'toUtc'],
    '/CcaSignUp/GetSignUpEventsForPupil': ['fromUtc', 'toUtc'],
    '/CcaSignUp/GetSignUpEventsTimeSlotted': ['fromUtc', 'toUtc'],
    '/CcaSignUp/GetSignUps': [
        'signUpsFrom',
        'signUpsTo',
        'openDateUtc',
        'closeDateUtc',
    ],
    '/CcaSignUp/GetSignUpsAvailableToCopy': [
        'openDateUtc',
        'closeDateUtc',
    ],
    '/CcaSignUp/GetStaffWithAllEvents': ['fromUtc', 'toUtc'],
    '/CcaSignUp/GetStaffWithBookedEvents': ['fromUtc', 'toUtc'],
    '/CcaSignUp/PopulateGroupCcaNamesAsync': ['LastEventDateUtc'],
    '/CcaSignUp/SaveAndFetchSignUpGroup': ['LastEventDateUtc'],
    '/CcaSignUp/SaveBookings': [
        'fromUtc',
        'toUtc',
        'startDateTimeUtc',
    ],
    '/CcaSignUp/SaveSignUpGroup': ['LastEventDateUtc'],
    '/CcaSignUp/SaveSignUpGroupEventAndReturnSavedEntity': [
        'signUpOpen',
        'signUpClose',
    ],
    '/CcaSignUp/StaffDeletePupilEvent': ['fromUtc', 'toUtc'],
    '/CcaSignUp/GetSignUpGroupsWithEventsForDeletionOrCancellation':
        ['eventDateUtc', 'eventEndDateUtc'],
    '/Reception/GetAttendanceGroups': ['eventsFrom', 'eventsTo'],
    '/Reception/GetEventSummary': [
        'eventsFrom',
        'eventsTo',
        'fromUtc',
        'toUtc',
        'eventsFromUtc',
        'eventsToUtc',
    ],
    '/Reception/GetLocationEvents': ['fromUtc', 'toUtc'],
    '/Reception/GetPersonData': ['lastAccessedUtc'],
    '/Reception/GetRegGroupNextEventData': [
        'fromDate',
        'eventTimeUtc',
    ],
    '/Reception/GetNextEventData': [
        'fromDate',
        'eventTime',
        'eventTimeUtc',
    ],
    '/webapi/WebBalanceAdministration/GetGroupSummariesAsync': [
        'from',
        'to',
    ],
    '/webapi/WebBalanceAdministration/GetGroupFeeSummariesAsync': [
        'from',
        'to',
        'minEventDateUtc',
    ],
    '/webapi/WebBalanceAdministration/GetEventSummariesForGroupAsync':
        ['from', 'to', 'eventDateUtc'],
    '/webapi/WebBalanceAdministration/GetPupilSummariesAsync': [
        'from',
        'to',
    ],
    '/webapi/WebBalanceAdministration/GetChargeTransactionsForAccount':
        ['eventFromUtc'],
    '/webapi/WebBalanceAdministration/GetAccountSummaries': [
        'transactionDateUtc',
    ],
    '/webapi/WebCalendarEventCreationRule/GetCalendarEventCreationRulesForSignUp':
        ['signUpOpenUtc', 'signUpCloseUtc'],
    '/webapi/WebCalendarEventCreationRule/GetCalendarEventCreationRulesForSignUpToPublish':
        ['signUpOpenUtc', 'signUpCloseUtc'],
    '/webapi/WebCalendarEventView/GetEventDetail': [
        'fromUtc',
        'toUtc',
        'meetingAtUtc',
        'signUpOpenUtc',
        'signUpCloseUtc',
        'routeStopDateTimeUtc',
        'pickupAtUtc',
    ],
    '/webapi/WebCcaPreferenceTeam/GenerateAdditionalEventsForActiveGroupsDatesAndDays':
        ['FromDateUtc', 'ToDateUtc'],
    '/webapi/WebCcaSignUp/GetSignUp': [
        'openDateUtc',
        'closeDateUtc',
    ],
    '/webapi/WebCcaSignUp/SaveSignUp': ['openDate', 'closeDate'],
    '/webapi/WebCcaSignUpCloneContainer/CloneAsync': [
        'openDate',
        'closeDate',
    ],
    '/webapi/WebChangeRequest/GetChangeRequest': [
        'calendarEventStartDateTimeUtc',
        'createdDateTimeUtc',
        'stopDateTimeUtc',
    ],
    '/webapi/WebChangeRequest/GetOptions': [
        'calendarEventStartDateTimeUtc',
        'stopDateTimeUtc',
    ],
    '/webapi/WebDiary/GetAll': [
        'fromDate',
        'toDate',
        'eventDateUtc',
        'eventEndDateUtc',
        'routeStopDateTimeUtc',
    ],
    '/webapi/WebDiary/GetInvites': [
        'eventDateUtc',
        'eventEndDateUtc',
    ],
    '/webapi/WebDiary/GetAllForTeam': [
        'subFromDate',
        'subToDate',
        'eventDateUtc',
        'eventEndDateUtc',
    ],
    '/webapi/WebEventRegisters/GetRegisterData': [
        'fromUtc',
        'toUtc',
        'meetingAtUtc',
        'transportAttendeeRouteStopTimeUtc',
        'timeStampUtc',
        'absenteeAlertSentUtc',
    ],
    '/webapi/WebEventRegisters/GetOfflineRegistersData': [
        'fromUtc',
        'toUtc',
        'meetingAtUtc',
        'eventStartTimeUtc',
        'eventEndTimeUtc',
        'transportAttendeeRouteStopTimeUtc',
        'absenteeAlertSentUtc',
    ],
    '/webapi/WebEventRegisters/GetRegisterNextEventData': [
        'eventStartTimeUtc',
        'eventEndTimeUtc',
    ],
    '/webapi/WebEventRegisters/GetRegisterPreviousEventData': [
        'eventStartTimeUtc',
        'eventEndTimeUtc',
    ],
    '/webapi/WebEventRegisters/SaveRegisterAttendeeAsync': [
        'registerUpdatedDateTimeUtc',
    ],
    '/webapi/WebEvents/EventsDelete': [
        'fromUtc',
        'toUtc',
        'meetingAtUtc',
        'signUpOpenUtc',
        'signUpCloseUtc',
        'pickupAtUtc',
    ],
    '/webapi/WebEvents/GetDetails': [
        'fromUtc',
        'toUtc',
        'meetingAtUtc',
        'signUpOpenUtc',
        'signUpCloseUtc',
        'pickupAtUtc',
    ],
    '/webapi/WebEvents/GetEventBasics': ['fromUtc'],
    '/webapi/WebEvents/GetEventInfo': ['lastDataSyncUtc'],
    '/webapi/WebEvents/GetStudentsForNotifyOnlyEvent': [
        'confirmedTimestampUtc',
        'lastUpdatedUtc',
    ],
    '/webapi/WebEvents/GetConsentEventInvitesData': [
        'consentDeadlineUtc',
    ],
    '/webapi/WebEvents/OtherDeletableEventsInSeries': [
        'fromUtc',
        'toUtc',
    ],
    '/webapi/WebEvents/Restore': [
        'fromUtc',
        'toUtc',
        'meetingAtUtc',
        'signUpOpenUtc',
        'signUpCloseUtc',
        'pickupAtUtc',
    ],
    '/webapi/WebEvents/Update': [
        'from',
        'to',
        'meetingAt',
        'signUpOpen',
        'signUpClose',
        'pickupAt',
        'fromUtc',
        'toUtc',
        'meetingAtUtc',
        'signUpOpenUtc',
        'signUpCloseUtc',
        'pickupAtUtc',
    ],
    '/webapi/WebEvents/UpdateLinked': [
        'fromUtc',
        'toUtc',
        'meetingAtUtc',
        'signUpOpenUtc',
        'signUpCloseUtc',
        'pickupAtUtc',
        'signUpOpen',
        'signUpClose',
        'pickupAt',
    ],
    '/webapi/WebGroup/GetFeeOnlyEventsForGroup': ['createdDateUtc'],
    '/webapi/WebGroup/GetGroupsWithChargeEventsByPartialNameByDateRange':
        ['eventFrom', 'eventTo'],
    '/webapi/WebGroup/GetChargeEventsByGroup': ['eventDateUtc'],
    '/webapi/WebMessageViewer/GetAdminInbox': ['saUtc'],
    '/webapi/WebMessageViewer/GetAdminInboxNewOnly': ['saUtc'],
    '/webapi/WebMessageViewer/GetSpecificMessage': [
        'saUtc',
        'roUtc',
        'soUtc',
        'aoUtc',
        'coUtc',
    ],
    '/webapi/WebMessageViewer/GetPersonInboxUnfiltered': [
        'saUtc',
        'roUtc',
        'soUtc',
        'aoUtc',
        'coUtc',
    ],
    '/webapi/WebMessageViewer/GetPersonInbox': [
        'saUtc',
        'roUtc',
        'soUtc',
        'aoUtc',
        'coUtc',
    ],
    '/webapi/WebMessageViewer/StarMessage': [
        'readOnUtc',
        'starredOnUtc',
        'acknowledgedOnUtc',
        'archivedOnUtc',
    ],
    '/webapi/WebMessageViewer/ArchiveMessage': [
        'readOnUtc',
        'starredOnUtc',
        'acknowledgedOnUtc',
        'archivedOnUtc',
    ],
    '/webapi/WebOrganisationChangeRequest/GetPendingChangeRequestsForApproval':
        [
            'calendarEventStartDateTimeUtc',
            'createdDateTimeUtc',
            'lastModifiedDateTimeUtc',
        ],
    '/webapi/WebOrganisationChangeRequest/GetFutureChangeRequestsApprovedOrRejected':
        [
            'calendarEventStartDateTimeUtc',
            'createdDateTimeUtc',
            'lastModifiedDateTimeUtc',
        ],
    '/webapi/WebOrganisationChangeRequest/GetTransportDiaryEventsByPupilName':
        ['eventDateUtc', 'eventEndDateUtc', 'routeStopDateTimeUtc'],
    '/webapi/WebOrganisationTransportMethod/GetMethods': [
        'createDateTimeUtc',
    ],
    '/webapi/WebOrganisationTransportRoutes/GetRoutes': [
        'createDateTimeUtc',
    ],
    '/webapi/WebOrganisationTransportStops/GetStops': [
        'createDateTimeUtc',
    ],
    '/webapi/WebOrganisationTransportTimetableCalendar/GetTransportTimetableCalendars':
        ['fromDateUtc', 'toDateUtc'],
    '/webapi/WebOrganisationTransportTimetableCalendar/GetTransportTimetableCalendar':
        ['fromDateUtc', 'toDateUtc'],
    '/webapi/WebOrganisationTransportTimetableCalendar/AddTransportTimetableCalendar':
        ['fromDate', 'toDate'],
    '/webapi/WebOrganisationTransportTimetableCalendar/EditTransportTimetableCalendar':
        ['fromDate', 'toDate'],
    '/webapi/WebOrganisationTransportTimetableCalendar/ValidateDateRangeForOverlaps':
        ['fromDate', 'toDate'],
    '/webapi/WebPersonPicker/GetPeopleWithFilters': ['liUtc'],
    '/webapi/WebTasks/GetAllForCaseId': [
        'createdUtc',
        'deadlineUtc',
    ],
    '/webapi/WebTasks/GetAllTasks': [
        'startDate',
        'endDate',
        'createdUtc',
        'deadlineUtc',
    ],
    '/webapi/WebTasks/GetById': ['createdUtc', 'deadlineUtc'],
    '/webapi/WebTasks/MarkCompleted': [
        'created',
        'createdUtc',
        'deadline',
        'deadlineUtc',
    ],
    '/webapi/WebTasks/Save': [
        'created',
        'deadline',
        'createdUtc',
        'deadlineUtc',
    ],
    '/webapi/WebTeam/GetTeamAttendance': [
        'eventsFrom',
        'eventsTo',
        'fromUtc',
    ],
    '/webapi/WebTeam/GetTeamAttendanceReport': [
        'eventsFrom',
        'eventsTo',
        'fromUtc',
    ],
    '/webapi/WebStaff/GetStaffForSchedule': ['start', 'end'],
    '/webapi/WebStaff/GetStaffMemberSchedule': [
        'start',
        'end',
        'eventDateUtc',
        'eventEndDateUtc',
    ],
};

export const legacyDateTimeRegexWhitelist = [
    {
        rx: /\/api\/Admin\/\d+\/Balance\/GetMoniesReceived/,
        props: [
            'transFromDateUtc',
            'transToDateUtc',
            'transactionDateUtc',
            'eventDateUtc',
        ],
    },
    {
        rx: /\/api\/Admin\/\d+\/BillingCycle\/Cycle\/\d+\/Batches/,
        props: ['createdDateTimeUtc', 'createdDateTime', 'orderBy'],
    },
    {
        rx: /\/api\/Admin\/\d+\/BillingCycle\/Cycle\/\d+\/Batch\/\d+/,
        props: ['createdDateTimeUtc'],
    },
    {
        rx: /\/api\/Admin\/\d+\/BillingCycle\/Cycle\/\d+\/Invoices/,
        props: ['dueDate'],
    },
    {
        rx: /\/api\/Admin\/\d+\/Communication\/AllMessages/,
        props: ['dateTimeSentUtc'],
    },
    {
        rx: /\/api\/Admin\/\d+\/BillingCycle\/Cycle\/\d+\/Products/,
        props: ['lastInvoicedDateTimeUtc'],
    },
    {
        rx: /\/api\/Admin\/\d+\/Invoice\/Invoices/,
        props: [
            'dueDateUtc',
            'invoiceDateUtc',
            'overdueReminderSentDateUtc',
            'invoiceDate',
            'dueDate',
            'orderBy',
        ],
    },
    {
        rx: /\/api\/Admin\/\d+\/Invoice$/,
        props: ['dateTimeUtc'],
    },
    {
        rx: /\/api\/Admin\/\d+\/Invoice\/\d+$/,
        props: ['dateTimeUtc', 'datePaidUtc', 'dateIssuedUtc'],
    },
    {
        rx: /\/api\/Admin\/\d+\/Invoice\/\d+\/Payment/,
        props: ['datePaid'],
    },
    {
        rx: /\/api\/Admin\/\d+\/Invoice\/\d+\/CreditNote/,
        props: ['dateIssued'],
    },
    {
        rx: /\/api\/Admin\/\d+\/Student\/TuitionSearch/,
        props: ['enrollmentFrom', 'enrollmentTo'],
    },
    {
        rx: /\/api\/Admin\/\d+\/TransportEventStatus\/LiveRouteData/,
        props: ['routeStartTimeUtc'],
    },
    {
        rx: /\/api\/Admin\/\d+\/TransportEventStatus\/LiveRouteEventData/,
        props: [
            'routeStartDateTimeUtc',
            'expectedStopTimeUtc',
            'loggedTimeUtc',
            'scheduledStopTimeUtc',
        ],
    },
    {
        rx: /\/api\/Admin\/\d+\/Events\/ConsentEventSettings/,
        props: ['consentDeadline'],
    },
];
